'use client';

import { CCQuestionnaireProvider } from '@/contexts/carConditionQuestionnaire.context';

export default function SellGroupLayout({
    children,
}: {
    children: React.ReactNode;
}) {
    return <CCQuestionnaireProvider>{children}</CCQuestionnaireProvider>;
}
